
const getTime = () => {
    const addZero = (n) => {
        return (parseInt(n, 10) < 10 ? '0' : '') + n;
    };

    let today = new Date();
        console.log(today.getDate())
        let month;
        switch (today.getMonth()){
            case 0:
                month = 'Jan';
                break;
            case 1:
                month = 'Feb';
                break;
            case 2:
                month = 'Mar';
                break;
            case 3:
                month = 'Apr';
                break;
            case 4:
                month = 'May';
                break;
            case 5:
                month = 'Jun';
                break;
            case 6:
                month = 'Jul';
                break;
            case 7:
                month = 'Aug';
                break;
                default: 
            case 8:
                month = 'Sep';
                break;
            case 9:
                month = 'Oct';
                break;
            case 10:
                month = 'Nov';
                break; 
            case 11:
                month = 'Dec';
                break;  
            month = ''
        };

    console.log(month);

    let hour = today.getHours();
    const amPm = hour >= 12 ? 'pm' : 'am';
    hour = hour % 12 || 12;


    let minute = today.getMinutes();
    let date = today.getDate();

    return `${month}${" "}${date},${" "}${addZero(hour)}:${addZero(minute)}${" "}${amPm}`
}

export default getTime;